import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
export const fetchStreamDataLake = (streamId) => fetch("GET", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.get_stream_data_lake(streamId).url));
const useStreamDataLake = (streamId) => {
  const { data, refetch, isFetching, error } = useQuery({
    queryKey: ["data-lake", "stream", streamId],
    queryFn: () => fetchStreamDataLake(streamId),
    placeholderData: keepPreviousData,
    retry: 1
  });
  return {
    streamDataLakeData: {
      data,
      refetch,
      isFetching,
      error
    }
  };
};
export default useStreamDataLake;
